import * as z from 'zod';
import { DEFAULT_PAGE_SIZE, FIRST_PAGE } from '@noor/config';

/**
 * URL search-param schemas for the merchants surfaces. The routes'
 * `validateSearch` uses these, so the URL is the single source of truth.
 */

export const merchantListSearchSchema = z.object({
  // Typed search: `search_type` names the column (`MERCHANT_SEARCH_TYPES`),
  // `search_value` carries the query. Both ride the wire as-is to
  // `GET /api/v1/admin/merchants/filter` (no vertical filter).
  // Coerced (not strict strings): the router JSON-parses search params, so a
  // bare numeric URL (`?search_value=123`, the everyday INN lookup) arrives
  // as a number — rejecting it would crash route validation on bookmarks and
  // shared links.
  search_type: z.coerce.string().optional(),
  search_value: z.coerce.string().optional(),
  // Status filter (`active` | `suspended` | `archived`). Omitted — everything
  // except archived. Unknown values fall through (never crash route
  // validation on hand-made links); the wire builder drops them.
  status: z.enum(['active', 'suspended', 'archived']).optional().catch(undefined),
  page: z.coerce.number().int().positive().default(FIRST_PAGE),
  pageSize: z.coerce.number().int().positive().default(DEFAULT_PAGE_SIZE),
});
export type MerchantListSearch = z.infer<typeof merchantListSearchSchema>;

export const integrationTokenSearchSchema = z.object({
  // Phone search — named `phone` (not `search`) so it never collides with the
  // layout header's global `search` param on this route.
  phone: z.string().optional(),
  scope: z.string().default('business'),
  status: z.string().default('not_migrated'),
  page: z.coerce.number().int().positive().default(FIRST_PAGE),
  pageSize: z.coerce.number().int().positive().default(DEFAULT_PAGE_SIZE),
});
export type IntegrationTokenSearch = z.infer<typeof integrationTokenSearchSchema>;
